export interface HomepageFaq {
  q: string
  a: string
}

export const homepageFaqs: HomepageFaq[] = [
  {
    q: 'What is Oorva?',
    a: 'Oorva is a local experience company in Tamil Nadu, India. We curate bookable artisan workshops, farm walks, traditional food experiences and folk arts hosted by verified local artisans, farmers, cooks and storytellers.',
  },
  {
    q: 'How do I book an authentic local experience?',
    a: 'Pick an experience in Thanjavur, Kancheepuram or Coimbatore and send a free request. Our team confirms availability, group size and the full cost with you on WhatsApp before you pay anything.',
  },
  {
    q: 'Do I need to pay in advance?',
    a: 'No payment now. You request a date for free, we confirm seats and the full cost personally, and only then do you pay.',
  },
  {
    q: 'Are Oorva experiences suitable for families?',
    a: 'Yes. Groups are small, hosts are verified locals, and the pace suits kids and elders. Tell us about accessibility needs and we will plan with the host family.',
  },
  {
    q: 'Where does Oorva operate?',
    a: 'We are live in Thanjavur and Coimbatore, with weekend trips in Thanjavur every Saturday and Sunday. Kancheepuram is opening next, with Madurai and the Nilgiris to follow.',
  },
]
